import { Component, EventEmitter, Input, OnInit, Output, CUSTOM_ELEMENTS_SCHEMA, SimpleChanges, ChangeDetectorRef } from '@angular/core';

import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatStepperModule } from '@angular/material/stepper';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';

@Component({
    selector: 'app-pertinence-existence-form',
    imports: [
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
    MatStepperModule,
    ReactiveFormsModule,
    MatChipsModule
],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    templateUrl: './pertinence-existence-form.component.html',
    styleUrls: ['./pertinence-existence-form.component.scss']
})
export class PertinenceExistenceFormComponent implements OnInit {
  @Input() pertinenceForm!: FormGroup;
  @Output() formSubmit = new EventEmitter<FormGroup>();
  @Output() filesSelected = new EventEmitter<File[]>();
  @Input() isFileRequired: boolean = false;
  @Input() motif: string = '';

  isDragging = false;
  invalidFile: boolean = false;
  selectedFileNames: File[] = [];
  nbreCaratereTextarea1: string = "Votre texte ne doit pas dépasser 350 caractères."
  nbreCaratereTextarea2: string = "Votre texte ne doit pas dépasser 720 caractères."
  constructor(
    private readonly fb: FormBuilder,
    private readonly cdRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.pertinenceForm.addControl('files', new FormControl([], this.isFileRequired ? Validators.required : []));
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['motif']) {
      const fileCtrl = this.pertinenceForm.get('files');

      if (this.motif === 'refusContratConditions') {
        this.isFileRequired = true;
        fileCtrl?.setValidators([Validators.required]);
      } else {
        this.isFileRequired = false;
        fileCtrl?.clearValidators();
        fileCtrl?.setValue(null);
      }

      fileCtrl?.updateValueAndValidity();
    }
  }

  get isNextButtonDisabled(): boolean {
    if (this.isFileRequired) {
      return this.pertinenceForm.get('files')?.invalid ?? true;
    }
    return false;
  }

  onSubmit() {
    if (this.pertinenceForm.valid) {
      this.formSubmit.emit(this.pertinenceForm);
    }
  }

  onReset() {
    this.pertinenceForm.reset();
  }

  onFileSelected(event: any) {
    if (event.target.files) {
      const files = Array.from(event.target.files) as File[];
      const pdfFiles = files.filter((file) => file.type === 'application/pdf');

      if (pdfFiles.length === files.length) {
        this.invalidFile = false;
        this.selectedFileNames = [...this.selectedFileNames, ...pdfFiles];
        this.pertinenceForm.get('files')?.setValue(this.selectedFileNames);
        this.filesSelected.emit(this.selectedFileNames);
      } else {
        this.invalidFile = true;
      }
    }
    if (event.target) {
      // Reset input so selecting the same file again triggers a change event.
      event.target.value = '';
    }
  }
  removeFile(index: number) {
    this.selectedFileNames.splice(index, 1);
    this.pertinenceForm.get('files')?.setValue(this.selectedFileNames);
  }
  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }
  handleDragDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;

    if (event.dataTransfer?.files) {
      const droppedFiles = Array.from(event.dataTransfer.files) as File[];
      const pdfFiles = droppedFiles.filter((file) => file.type === 'application/pdf');

      if (pdfFiles.length !== droppedFiles.length) {
        this.invalidFile = true;
        return;
      }

      this.invalidFile = false;

      const updatedFiles = [...this.selectedFileNames, ...pdfFiles];
      this.selectedFileNames = updatedFiles;
      this.pertinenceForm.get('files')?.patchValue([...updatedFiles]);
      const filesCtrl = this.pertinenceForm.get('files');
      filesCtrl?.setValue(updatedFiles);
      filesCtrl?.markAsTouched();
      filesCtrl?.markAsDirty();
      filesCtrl?.updateValueAndValidity();
      this.filesSelected.emit(this.selectedFileNames);
    }
    this.cdRef.detectChanges();
  }
  triggerFileInput(fileInput: HTMLInputElement) {
    fileInput.click();
  }
}
